import OnboardingPartnerConfiguration from "@gamedev-web/partner-onboarding";

import type { AnyPartnerConfiguration } from "@gamedev-web/gamedev-sdk-core";

export const partnerConfigurations: AnyPartnerConfiguration[] = [
  OnboardingPartnerConfiguration,
].filter(partner => partner && "partnerId" in partner);
